import { Tag } from "primereact/tag";

import { ConfirmarSituacaoDialog } from "@/shared/components";
import styles from "./inativar-ativar-escopo-padrao.module.scss";
import type { InativarAtivarEscopoPadraoViewModel } from "./types-inativar-ativar-escopo-padrao";

export function InativarAtivarEscopoPadraoView({
  acao,
  titulo,
  subtitulo,
  confirmLabel,
  tituloEfeitos,
  oQueAcontece,
  identificacao,
  onConfirmar,
  onCancelar,
}: InativarAtivarEscopoPadraoViewModel) {
  return (
    <ConfirmarSituacaoDialog
      acao={acao}
      titulo={titulo}
      subtitulo={subtitulo}
      confirmLabel={confirmLabel}
      tituloEfeitos={tituloEfeitos}
      oQueAcontece={oQueAcontece}
      corpo={
        <div className={styles.identificacao} data-testid="inativar-ativar-escopo-identificacao">
          <p className={styles.intro}>{identificacao.intro}</p>
          <p className={styles.nome}>
            <strong>{identificacao.nome}</strong>
            {identificacao.tag ? <Tag value={identificacao.tag} severity="secondary" /> : null}
          </p>
          <p className={styles.detalhe}>{identificacao.detalhe}</p>
        </div>
      }
      onConfirmar={onConfirmar}
      onCancelar={onCancelar}
    />
  );
}
